export default "__VITE_ASSET__4ef7f79f__"